import { MeWithAccessRecordsApiResponse } from '@youscience/bpa-common';

export const isECPEnabled = (userData: MeWithAccessRecordsApiResponse) => {
  const ecpAvailability = userData.access.some((access) => access.tenant.productAvailability?.ecp);

  return ecpAvailability;
};
